import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getAuditTrail as getAuditTrailApi } from '../api/auditTrailApi'
import { HttpResponseStatusCodes } from '../constants'
import {
  AUDIT_TRAIL_RETRIEVAL_FAILED,
  TEMPORARILY_UNAVAILABLE,
} from './constants'

export const GET_AUDIT_TRAIL = 'GET_AUDIT_TRAIL'
export const GET_AUDIT_TRAIL_SUCCESS = 'GET_AUDIT_TRAIL_SUCCESS'
export const GET_AUDIT_TRAIL_FAILURE = 'GET_AUDIT_TRAIL_FAILURE'

export const getAuditTrail = (dispatch: Dispatch, processingCaseId: number) => {
  dispatch({ type: GET_AUDIT_TRAIL })
  getAuditTrailApi(processingCaseId)
    .then((response: AxiosResponse) => {
      const auditTrail = response.data
      dispatch({ type: GET_AUDIT_TRAIL_SUCCESS, auditTrail })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : AUDIT_TRAIL_RETRIEVAL_FAILED
      dispatch({ type: GET_AUDIT_TRAIL_FAILURE, errorMessage })
    })
}
